<template>
  <div>
  <header-mx></header-mx>
    <section class="main dashboard">
      <div class="figuras top">
        <!-- <div class="container-fluid pb-3">
          <div class="row">
            <div class="col-sm-12">
              <div class="row" data-aos="fade-up" data-aos-delay="200" data-aos-duration="500">
                 <div class="col-md-6 pt-4">
                  <h2 class="naranja">¡Hola Juan!</h2>
                  <h2>¿Qué necesitas hacer?</h2>
                </div>

                <div class="col-md-6 pt-4">
                  <div class="float-md-right">
                    <div class="status">
                      <div>
                        <i class="far fa-check-circle fa-2x"></i>
                      </div>
                      <div>
                        <div>Contrato activo</div>
                        <div>Vigencia: 20 de marzo de 2020</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>-->

        <div class="pt-3">
          <div
            class="row no-gutters"
            data-aos="fade-right"
            data-aos-delay="10"
            data-aos-duration="500"
          >
            <menu-lat></menu-lat>

            <div class="col-md-10">
              <div class="row headercontenido">
                <div class="col-6 col-md-6">
                  <span class="titulo sub">
                    <router-link to="/dashboard/docentes">Docentes</router-link>
                  </span>
                </div>
                <div class="col-6 col-md-6">
                  <router-link class="btnblanco float-right"
                  to="/dashboard/docentes/alta">
                    Nuevo docente
                    <i class="fa fa-plus-circle"></i>
                  </router-link>
                </div>
              </div>

              <div class="contenido">
                <div class="row">
                  <div class="col-12" v-if="this.data != null">
                    <v-client-table :columns="columns" v-model="data" :options="options">
                      <router-link
                        slot="uri"
                        slot-scope="props"
                        :to="'/dashboard/docentes/edicion/'+props.row.matricula"
                        class="text-center link"
                      >
                        <i class="fas fa-edit"></i>
                      </router-link>

                      <div
                        slot="baja"
                        slot-scope="props"
                        @click="baja(props.row.matricula, props.row.nombre)"
                        class="text-center link"
                      >
                        <i class="fas fa-times"></i>
                      </div>

                      <div
                        slot="banned"
                        slot-scope="props"
                        @click="bloqueo(props.row.matricula, props.row.nombre, props.row.banned)"
                        class="text-center link"
                      >
                        <i v-if="props.row.banned == 0" class="fas fa-lock-open"></i>
                        <i v-if="props.row.banned == 1" class="fas fa-lock"></i>
                      </div>

                      <div slot="grupos" slot-scope="props">
                        <div v-for="item in props.row.grupos" v-bind:key="item.id_grupo">
                          <div> &bull; {{item.nombre}} ({{item.ciclo_escolar_ano}})</div>
                        </div>
                      </div>
                    </v-client-table>
                  </div>
                </div>

                <span class="loading" v-bind:class="{active: this.$store.state.loading}">
                  <img src="../../assets/imgs/DualRing-1.1s-28px.svg" alt="loading" />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<style>
@import "//netdna.bootstrapcdn.com/bootstrap/3.0.0/css/bootstrap-glyphicons.css";
</style>
<script>
import AOS from "aos";
import swal from "sweetalert2";
import Header from "../../Components/Header.vue";
import Menu from "../../Components/Menu.vue";
import { ServerTable, ClientTable, Event } from "vue-tables-2";

import Vue from "vue";
Vue.use(ClientTable);

export default {
  name: "IEEServiciosAcademicos",
  props: {
    msg: String
  },
  data() {
    return {
      tiposervicio: "",
      columns: [
        "matricula",
        "nombre",
        "user_email",
        "grupos",
        "uri",
        "baja"
      ],
      datos: null,
      data: null,
      options: {
        perPage: 5,
        perPageValues: [5, 10, 15, 25, 50, 100],
        headings: {
          matricula: "No. de Docente",
          nombre: "Nombre",
          user_email: "Email",
          grupos: "Grupos",
          uri: "Actualización de datos",
          baja: "Baja"
        },
        editableColumns: ["name"],
        sortable: ["matricula", "nombre", "user_email", "grupos"],
        pagination: {
          show: true,
          dropdown: false,
          chunk: 10,
          edge: true,
          align: "center",
          nav: "fixed"
        },
        texts: {
          count:
            "Mostrando desde {from} hasta {to} - {count} registros|{count} registros|Un registro",
          first: "Primera",
          last: "Última",
          filter: "",
          filterPlaceholder: "Búsqueda",
          limit: "",
          page: "Página:",
          noResults: "No se encontraron resultados.",
          filterBy: "Filtrando por {column}",
          loading: "Cargando...",
          defaultOption: "Seleccionar {column}",
          columns: "Columnas"
        }
      }
    };
  },
  components: {
    "header-mx": Header,
    "menu-lat": Menu
  },
  mounted: function() {
  this.$store.state.user = JSON.parse(this.$cookie.get('useriee'));
    AOS.init();

    this.consulta();
  },
  methods: {
    consulta() {
      console.log("consulta");
      var vm = this;
      const https = require("https");
      vm.$store.state.loading = true;

      var qData = {
        id_plantel: this.$store.state.user.id_plantel
      };

      let formData = new FormData();
      formData.append("form_data", JSON.stringify(qData));

      console.log(JSON.stringify(qData));

      this.$http
        .post(
          vm.$store.state.baseurl + "docentes/consulta-docente.php",
          formData,
          {
            emulateJSON: true,
            httpsAgent: new https.Agent({ rejectUnauthorized: false }),
            headers: {
              "Content-Type": "multipart/form-data"
              //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
            }
          }
        )
        .then(
          response => {
            // get body data
            console.log("envio");
            console.log(response);
            vm.$store.state.loading = false;
            var res = response.body;

            if (res.status == "ok") {
              console.log("ok");
              this.data = res.datos;
            } else if (res.status == "notok") {
              swal.fire("Oops", res.msg, "warning");
            }
          },
          error => {
            // error callback
            console.log("error callback");
            console.log(error);
            vm.$store.state.loading = false;
            //console.log(userData);
            swal.fire(
              "Oops",
              "Ha ocurrido un error, por favor intenta de nuevo.",
              "warning"
            );
          }
        );
    },
    baja(matricula, nombre) {
      swal
        .fire({
          title:
            "¿Eliminar al docente '" +
            nombre +
            "' con No. de docente '" +
            matricula +
            "'?",
          text: "En caso de continuar no se podrá revertir el cambio.",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Sí, eliminar",
          cancelButtonText: "Cancelar"
        })
        .then(result => {
          if (result.value) {
            console.log("eliminando");
            var vm = this;
            const https = require("https");
            vm.$store.state.loading = true;

            var qData = {
              matricula: matricula
            };

            let formData = new FormData();

            formData.append("form_data", JSON.stringify(qData));
            //formData.append("cv", this.file);

            console.log("enviando");
            //console.log(this.file);
            console.log(JSON.stringify(qData));

            this.$http
              .post(
                vm.$store.state.baseurl + "alumnos/baja-de-alumno.php",
                formData,
                {
                  emulateJSON: true,
                  httpsAgent: new https.Agent({ rejectUnauthorized: false }),
                  headers: {
                    "Content-Type": "multipart/form-data"
                    //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
                  }
                }
              )
              .then(
                response => {
                  // get body data
                  console.log("envio");
                  console.log(response);
                  vm.$store.state.loading = false;
                  console.log(response.data);
                  var res = response.data;

                  if (res.status == "ok") {
                    swal
                      .fire("¡Eliminado!", res.msg, "success")
                      .then(result => {
                        if (result.value) {
                          this.$router.go();
                        }
                      });
                  } else if (res.status == "notok") {
                    swal.fire("Oops", res.msg, "warning");
                  }
                },
                error => {
                  // error callback
                  console.log("error callback");
                  console.log(error);
                  vm.$store.state.loading = false;
                  //console.log(userData);
                  swal.fire(
                    "Oops",
                    "Ha ocurrido un error, por favor intenta de nuevo.",
                    "warning"
                  );
                }
              );
          }
        });
    },
    bloqueo(matricula, nombre, banned) {
      var url = "alumnos/bloquear-alumno.php";
      var mensaje =
        "¿Bloquear al docente '" +
        nombre +
        "' con No. de Docente '" +
        matricula +
        "'?";
      var mensaje2 = "Sí, bloquear";

      if (banned == 1) {
        url = "alumnos/desbloquear-alumno.php";
        mensaje =
          "¿Desbloquear al docente '" +
          nombre +
          "' con No. de Docente '" +
          matricula +
          "'?";
        mensaje2 = "Sí, desbloquear";
      }

      swal
        .fire({
          title: mensaje,
          text: "",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: mensaje2,
          cancelButtonText: "Cancelar"
        })
        .then(result => {
          if (result.value) {
            console.log("bloqueando");
            var vm = this;
            const https = require("https");
            vm.$store.state.loading = true;

            var qData = {
              matricula: matricula
            };

            let formData = new FormData();

            formData.append("form_data", JSON.stringify(qData));
            //formData.append("cv", this.file);

            console.log("enviando");
            //console.log(this.file);
            console.log(JSON.stringify(qData));

            this.$http
              .post(vm.$store.state.baseurl + url, formData, {
                emulateJSON: true,
                httpsAgent: new https.Agent({ rejectUnauthorized: false }),
                headers: {
                  "Content-Type": "multipart/form-data"
                  //Authorization: "Token 271fa2c5e7851e5552f05653fd6a35c7ee597fa4",
                }
              })
              .then(
                response => {
                  // get body data
                  console.log("envio");
                  console.log(response);
                  vm.$store.state.loading = false;
                  console.log(response.data);
                  var res = response.data;

                  if (res.status == "ok") {
                    swal.fire("Bien", res.msg, "success").then(result => {
                      if (result.value) {
                        this.$router.go();
                      }
                    });
                  } else if (res.status == "notok") {
                    swal.fire("Oops", res.msg, "warning");
                  }
                },
                error => {
                  // error callback
                  console.log("error callback");
                  console.log(error);
                  vm.$store.state.loading = false;
                  //console.log(userData);
                  swal.fire(
                    "Oops",
                    "Ha ocurrido un error, por favor intenta de nuevo.",
                    "warning"
                  );
                }
              );
          }
        });
    }
  }
};
</script>

